import { useNavigate } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { Loading } from "../../components/LoadState";
import { InventoryController } from "./inventory-controller";

export function InventoryRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  return (
    <Subtree
      key="inventory"
      controller={() =>
        new InventoryController(pick(deps, "client", "authHandler", "storeRepository", "reviewQueueRepository"), {
          toReview: () => navigate("/drafts", { replace: true }),
          toStock: () => navigate("/cards", { replace: true }),
        })
      }
    >
      <div className="mx-auto max-w-4xl px-4 py-8">
        <Loading label="Opening Inventory…" />
      </div>
    </Subtree>
  );
}
